import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Landmark, LogOut, Award, User, MessageSquarePlus } from "lucide-react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  const linkCls = (active) =>
    `text-sm tracking-wide uppercase font-medium transition-colors duration-200 ${
      active ? "text-[#0A0A0A]" : "text-[#525252] hover:text-[#0A0A0A]"
    }`;

  return (
    <header className="sticky top-0 z-40 bg-[#FFFFFF]/95 backdrop-blur border-b border-[#E5E5E0]">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" data-testid="brand-logo" className="flex items-center gap-2.5 group">
          <Landmark className="w-6 h-6 text-[#0A0A0A]" strokeWidth={1.75} />
          <div className="leading-tight">
            <div className="font-serif text-xl font-bold text-[#0A0A0A] tracking-tight">
              YesVersity
            </div>
            <div className="font-mono text-[10px] tracking-[0.15em] uppercase text-[#525252]">
              India · Dubai
            </div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          <Link data-testid="nav-modules" to="/modules" className={linkCls(loc.pathname.startsWith("/modules"))}>
            Modules
          </Link>
          {user && user !== false && (
            <>
              <Link data-testid="nav-dashboard" to="/dashboard" className={linkCls(loc.pathname === "/dashboard")}>
                Dashboard
              </Link>
              <Link data-testid="nav-bookmarks" to="/bookmarks" className={linkCls(loc.pathname === "/bookmarks")}>
                Bookmarks
              </Link>
            </>
          )}
        </nav>

        <div className="flex items-center gap-3">
          <Link
            data-testid="nav-contributions"
            to="/contributions"
            className="inline-flex items-center gap-1.5 text-sm px-4 py-2 bg-[#C5A059] text-[#0A0A0A] hover:bg-[#A88643] transition-colors font-medium btn-primary-hover"
          >
            <MessageSquarePlus className="w-4 h-4" strokeWidth={1.75} />
            <span className="hidden sm:inline">Contributions</span>
          </Link>
          {user && user !== false ? (
            <>
              <Link
                data-testid="nav-reputation"
                to="/profile"
                className="hidden sm:inline-flex items-center gap-1 px-2 py-1 border border-[#E5E5E0] hover:border-[#0A0A0A] transition-colors text-xs font-mono uppercase tracking-wider text-[#0A0A0A]"
                title="Your reputation"
              >
                <Award className="w-3 h-3 text-[#C5A059]" />
                <span data-testid="nav-reputation-value">{user.reputation ?? 0}</span>
              </Link>
              <Link
                data-testid="nav-profile"
                to="/profile"
                className="hidden sm:inline-flex items-center gap-1.5 text-sm text-[#525252] hover:text-[#0A0A0A] transition-colors"
              >
                <User className="w-4 h-4" strokeWidth={1.75} />
                <span data-testid="nav-user-name">{user.name}</span>
              </Link>
              <button
                data-testid="nav-logout"
                onClick={async () => { await logout(); nav("/"); }}
                className="flex items-center gap-1.5 text-xs uppercase tracking-wider font-medium text-[#525252] hover:text-[#0A0A0A] transition-colors"
              >
                <LogOut className="w-4 h-4" strokeWidth={1.75} /> Sign out
              </button>
            </>
          ) : (
            <>
              <Link data-testid="nav-login" to="/login" className="text-sm text-[#525252] hover:text-[#0A0A0A] transition-colors">
                Sign in
              </Link>
              <Link
                data-testid="nav-signup"
                to="/register"
                className="text-sm px-4 py-2 bg-[#0A0A0A] text-[#FFFFFF] hover:bg-[#000000] transition-colors btn-primary-hover"
              >
                Start learning
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
